import { throttle } from 'throttle-debounce'

const chat = {
  el: {
    closeTrigger: document.querySelector<HTMLElement>('.chat__modal-close'),
    chat: document.querySelector<HTMLElement>('.chat'),
    footer: document.querySelector<HTMLElement>('.footer'),
    liveChatTrigger: document.querySelector<HTMLElement>('.livechat-trigger'),
    modal: document.querySelector<HTMLElement>('.chat__modal'),
    trigger: document.querySelector<HTMLElement>('.chat__trigger'),
  },

  init(): void {
    if (!this.el.modal) {
      return
    }

    this.el.trigger.addEventListener('click', this.toggleModal.bind(this))
    this.el.closeTrigger.addEventListener('click', this.toggleModal.bind(this))
    window.addEventListener('scroll', throttle(60, this.toggleVisibility).bind(this))

    this.initLiveChat()
    this.toggleVisibility()
  },

  initLiveChat(): void {
    //@ts-ignore
    // LC_API.open_chat_window();
    //@ts-ignore
    LiveChatWidget.on('visibility_changed', onVisibilityChanged)

    function onVisibilityChanged(data) {
      switch (data.visibility) {
        case 'maximized':
          document.querySelector<HTMLElement>('#chat-widget-container').style.visibility = 'visible'
          break
        case 'minimized':
          chat.toggleModal()
          setTimeout(() => {
            document.querySelector<HTMLElement>('#chat-widget-container').style.visibility = 'hidden'
            chat.el.liveChatTrigger.classList.remove('livechat-trigger--open')
          }, 300)
          break
        case 'hidden':
          break
      }
    }

    if (this.el.liveChatTrigger) {
      this.el.liveChatTrigger.addEventListener('click', () => {
        const isLiveChatOpen = this.el.liveChatTrigger.classList.contains('livechat-trigger--open')

        if (!isLiveChatOpen) {
          //@ts-ignore
          // LC_API.open_chat_window();
          //@ts-ignore
          if (!LiveChatWidget.init()) {
            //@ts-ignore
            // LC_API.open_chat_window();
            //@ts-ignore
            LiveChatWidget.init()
          }
        }

        //@ts-ignore
        // LC_API.open_chat_window();
        //@ts-ignore
        LiveChatWidget.call('maximize')

        if (!isLiveChatOpen) {
          this.el.liveChatTrigger.classList.add('livechat-trigger--open')
        }
      })
    }
  },

  toggleModal(): void {
    this.el.modal.classList.toggle('chat__modal--open')

    const isExpanded = this.el.modal.classList.contains('chat__modal--open')

    this.el.trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')
    this.el.closeTrigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')
  },

  toggleVisibility(): void {
    if (!this.el.footer) {
      return
    }

    if (window.innerHeight - this.el.footer.getBoundingClientRect().top > 0) {
      this.el.chat.classList.add('chat--hidden')
    } else {
      this.el.chat.classList.remove('chat--hidden')
    }
  },
}

export default chat
